import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MpjobService } from 'src/app/services/jobs/mpjob.service';
import { formIdLists, testReasonListsPOCT, yesNoArray } from '../../_models/staticArray';
import { UtilityService } from 'src/app/services/utility.service';
import { SignaturePadComponent } from 'src/app/commons/signature-pad/signature-pad.component';
import { UserDocumentService } from 'src/app/services/user-document.service';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import { AssetService } from 'src/app/services/asset.service';


@Component({
  selector: 'poct-test-form',
  templateUrl: './poct-test-form.component.html',
  styleUrls: ['./poct-test-form.component.scss']
})
export class PoctTestFormComponent implements OnInit {
  @Input('jobId') currentJob
  @Input('learnerData') learnerDetails
  @Input('openFilesSideNav') openFilesSideNav
  poctTestForm: FormGroup;
  formIdList = formIdLists
  userId
  currentUserDetails
  currentUserId
  currentJobId
  candidateList = []
  candidateName: any;
  candidateDisabled = false
  loading = false
  testResonList: any = testReasonListsPOCT
  yesnoList = yesNoArray
  poctFormDetails
  isEdit = false
  otherFormDetails
  files = []
  newFiles = []

  constructor(
    public _formBuilder: FormBuilder,
    public _activatedRoute: ActivatedRoute,
    public _router: Router,
    public _mpJobService: MpjobService,
    public _utilityService: UtilityService,
    public _userDocumentService: UserDocumentService,
    public _assetService: AssetService
  ) { }

  ngOnInit(): void {
    this._activatedRoute.params.subscribe(params => {
      console.log("Params", params)
      if (params.id) {
        this.userId = params.id
      }
      if (params.jobId) {
        this.currentJobId = params.jobId
        this.getCandidateList()
      }
    })

    this.createForm();
  }


  ngOnChanges(chanages: SimpleChanges) {

    if (chanages.currentJob && chanages.currentJob.currentValue) {
      console.log('currentJob', chanages.currentJob.currentValue)
      this.currentJobId = chanages.currentJob.currentValue
      console.log('currentJobId', this.currentJobId)
      this.getCandidateList()
    }
    if (chanages.learnerDetails && chanages.learnerDetails.currentValue) {
      this.currentUserDetails = chanages.learnerDetails.currentValue
      this.currentUserId = this.currentUserDetails.userModelId
      this.getPOCTForm()
    }
  }


  // FORM CONTROLS 


  createForm(data?) {
    console.log("THIS IS THE FORM DATA", data)
    this.poctTestForm = this._formBuilder.group({
      donorName: new FormControl((data && data.donorName) ? data.donorName : this.candidateName, Validators.required),
      companyName: new FormControl((data && data.companyName) ? data.companyName : ''),
      dobDate: new FormControl((data && data.dobDate) ? data.dobDate : (this.otherFormDetails && this.otherFormDetails.dob) ? this.otherFormDetails.dob : ''),
      testExprDate: new FormControl((data && data.testExprDate) ? data.testExprDate : ''),
      formOfId: new FormControl((data && data.formOfId) ? data.formOfId : (this.otherFormDetails && this.otherFormDetails.confirmId) ? this.otherFormDetails.confirmId : ''),
      testReason: new FormControl((data && data.testReason) ? data.testReason : (this.otherFormDetails && this.otherFormDetails.reasonForTest) ? this.otherFormDetails.reasonForTest : ''),
      insuranceNumber: new FormControl((data && data.insuranceNumber) ? data.insuranceNumber : (this.otherFormDetails && this.otherFormDetails.nationaInsuranceNumber) ? this.otherFormDetails.nationaInsuranceNumber : ''),
      sentinelNumber: new FormControl((data && data.sentinelNumber) ? data.sentinelNumber : (this.otherFormDetails && this.otherFormDetails.sentinelNumber) ? this.otherFormDetails.sentinelNumber : ''),
      poctLotNo: new FormControl((data && data.poctLotNo) ? data.poctLotNo : ''),
      inrRefNo: new FormControl((data && data.inrRefNo) ? data.inrRefNo : ''),
      date: new FormControl((data && data.date) ? data.date : (this.otherFormDetails && this.otherFormDetails.formDate) ? this.otherFormDetails.formDate : ''),
      location: new FormControl((data && data.location) ? data.location : (this.otherFormDetails && this.otherFormDetails.location) ? this.otherFormDetails.location : ''),
      donorDate: new FormControl((data && data.donorDate) ? data.donorDate : ''),
      donorSign: new FormControl((data && data.donorSign) ? data.donorSign : ''),
      donorSample: new FormControl((data && data.donorSample) ? data.donorSample : ''),
      temperature: new FormControl((data && data.temperature) ? data.temperature : ''),
      phValue: new FormControl((data && data.phValue) ? data.phValue : ''),
      gravity: new FormControl((data && data.gravity) ? data.gravity : ''),
      oxidants: new FormControl((data && data.oxidants) ? data.oxidants : ''),
      check1: new FormControl((data && data.check1) ? data.check1 : ''),
      check2: new FormControl((data && data.check2) ? data.check2 : ''),
      check3: new FormControl((data && data.check3) ? data.check3 : ''),
      check4: new FormControl((data && data.check4) ? data.check4 : ''),
      check5: new FormControl((data && data.check5) ? data.check5 : ''),
      check6: new FormControl((data && data.check6) ? data.check6 : ''),
      check7: new FormControl((data && data.check7) ? data.check7 : ''),
      check8: new FormControl((data && data.check8) ? data.check8 : ''),
      check9: new FormControl((data && data.check9) ? data.check9 : ''),
      check10: new FormControl((data && data.check10) ? data.check10 : ''),
      check11: new FormControl((data && data.check11) ? data.check11 : ''),
      check12: new FormControl((data && data.check12) ? data.check12 : ''),
      check13: new FormControl((data && data.check13) ? data.check13 : ''),
      check14: new FormControl((data && data.check14) ? data.check14 : ''),
      check15: new FormControl((data && data.check15) ? data.check15 : ''),
      check16: new FormControl((data && data.check16) ? data.check16 : ''),
      check17: new FormControl((data && data.check17) ? data.check17 : ''),
      check18: new FormControl((data && data.check18) ? data.check18 : ''),
      name1: new FormControl((data && data.name1) ? data.name1 : ''),
      sign1: new FormControl((data && data.sign1) ? data.sign1 : ''),
      date1: new FormControl((data && data.date1) ? data.date1 : ''),
      name2: new FormControl((data && data.name2) ? data.name2 : ''),
      sign2: new FormControl((data && data.sign2) ? data.sign2 : ''),
      date2: new FormControl((data && data.date2) ? data.date2 : ''),
      name3: new FormControl((data && data.name3) ? data.name3 : ''),
      sign3: new FormControl((data && data.sign3) ? data.sign3 : ''),
      date3: new FormControl((data && data.date3) ? data.date3 : '')
    })
  }




  // UTILITY


  onChange(event, formControl) {
    this.poctTestForm.controls[formControl].setValue(event)
    console.log("VALUE OF FORM ", this.poctTestForm.value)
  }

  /**
   * @param formControl control name of different signature
   * Open signature pad and get signature
   * Assign signature to formControl
   */

  addSignature(formControl) {
    this._utilityService.commonDialogBoxOpen(SignaturePadComponent)
      .afterClosed()
      .subscribe(data => {
        if (data === undefined) return
        else {
          this.poctTestForm.controls[formControl].setValue(data)
        }
        console.log("data from signature", this.poctTestForm.value)
      })
  }

  optionClicked(user) {
    console.log("VALUE OF CURRENT FORM", this.poctTestForm.value, user)
    let index = this.candidateList.findIndex(x => x.userModelId === user.userModelId)
    console.log("CURRENT INDEX ", index)
    if (index >= 0) {
      console.log("FIND USER VALUE", this.candidateList[index])
      this.currentUserId = this.candidateList[index].userModelId
    }
  }


  addFileModal() {
    let obj = {
      isIncident: true
    }
    this._utilityService.commonDialogBoxOpen(NewFileModalComponent, obj, '', '100%', '100vw', '100vh').afterClosed().subscribe((fileQueue) => {
      console.log("The queue recieved is", fileQueue);
      if (fileQueue == undefined || fileQueue.length == 0) return;
      fileQueue.forEach(file => {
        if (this.isEdit) this.newFiles.push(file)
        else this.files.push(file);
      })
    })
  }

  fileDetails(event) {
    this._assetService.displayFile(event)
  }

  deleteFile(event, index) {
    this.files.splice(index, 1)
    console.log("after file removd", this.files);
  }

  deleteNewFile(event, index) {
    this.newFiles.splice(index, 1)
  }

  // API CALL


  /**
   * Get all candidate list by job id
   */
  getCandidateList() {
    this._mpJobService.getAllCandidateList(this.currentJobId).subscribe(res => {
      console.log('res in form', res)
      this.candidateList = res
      let index = this.candidateList.findIndex(x => x.userId === this.userId)
      if (index > -1) {
        console.log('seletcted Candidate', this.candidateList[index])
        this.candidateName = this.candidateList[index].name
        this.poctTestForm.controls.donorName.setValue(this.candidateName);
        this.candidateDisabled = true
      }
      console.log("ALL CANDIDATE LIST", this.candidateList)
      this.loading = false
    }, error => {
      console.log("error while get candidate list", error)
      this.loading = false
    })
  }

  submitPOCTForm() {
    this.loading = true
    console.log("POCT FORM", this.poctTestForm.value)
    let obj = {
      metaObj: {
        title: 'poctTestForm',
      },
      documentId: this.currentJobId,
      userId: this.currentUserId,
      onModel: 'mpjob',
      files: this.files,
      details: {}
    }
    let details = {
      poctTestForm: this.poctTestForm.value
    }
    obj['details'] = details
    if (this.isEdit) {
      obj['userDocumentId'] = this.poctFormDetails._id
      obj['documentMetaId'] = this.poctFormDetails.documentMetaId._id
      obj['newFiles'] = this.newFiles
      console.log("THIS IS THE UPDATE DOCUMENT", obj)
      this._userDocumentService.updateUserDocument(obj).subscribe((response) => {
        console.log("response of new user document", response);
        this.loading = false
        this._utilityService.handleSnackBar({ msg: "POCT Test form updated successfully!", button: "OK" })
        this._router.navigateByUrl('/mpjob/' + this.currentJobId)
      }, error => {
        console.log("error while submit form", error);
        this._utilityService.handleSnackBar({ msg: error.msg, button: "OK" })
        this.loading = false
      })
    } else {
      this._userDocumentService.addUserDocument(obj).subscribe((response) => {
        console.log("response of new user document", response);
        this.loading = false
        this._utilityService.handleSnackBar({ msg: "POCT Test form added successfully!", button: "OK" })
        this._router.navigateByUrl('/mpjob/' + this.currentJobId)
        // this.redirect()
      }, error => {
        console.log("error while submit form", error);
        this._utilityService.handleSnackBar({ msg: error.msg, button: "OK" })
        this.loading = false
      })
    }
  }

  getPOCTForm() {
    let obj = {
      accidentId: this.currentJobId,
      userId: this.currentUserId,
      type: 'poctTestForm',
      testedIndividualId: this.currentUserDetails.userId
    }
    this._userDocumentService.getBreathAlcoholDocument(obj).subscribe((response) => {
      console.log("RESPONSE OF BREATH ALCOHOL FORM", response);
      if (response.document && response.document.length) {
        const formDetails = response.document.find((x) => x.documentMetaId.title === 'poctTestForm')
        if (formDetails !== undefined) {
          this.poctFormDetails = formDetails
        }
        // const otherFormDetails = response.find((x) => x.documentMetaId.title === 'breathAlcoholForm')
        // if (otherFormDetails !== undefined) {
        //   this.otherFormDetails = otherFormDetails.details.breathAlcoholForm
        //   console.log("OTHER FORM DETAILS", this.otherFormDetails)
        // }
      }
      this.otherFormDetails = response.common

      // console.log("RESPONSE OF BREATH ALCOHOL FORM", this.breathAlcoholFormDetails);
      if (this.poctFormDetails) {
        console.log("THIS IS THE SINGLE FORM DETAILS", this.poctFormDetails);
        this.files = this.poctFormDetails.files
        this.isEdit = true
        this.createForm(this.poctFormDetails.details.poctTestForm)
      } else {
        this.createForm()
      }
      this.loading = false
    }, error => {
      console.log("ERROR WHILE GET USER FORM", error)
      this.loading = false
    })
  }

}
